// extracted by mini-css-extract-plugin
export default {"goBottom":"Comments_goBottom__iNsXn","arrowHop":"Comments_arrowHop__NOy2p","visible":"Comments_visible__kN5Mo"};